export default "__VITE_ASSET__D0G7YoZr__"